<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.namefr"
            :error-messages="namefrErrors"
            :label="$t('global.namefr')"
            required
            @input="$v.item.namefr.$touch()"
            @blur="$v.item.namefr.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('qualitycheck.product.notice') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.notice"
                :error-messages="noticeErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('qualitycheck.product.updatesoft') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.updateSoft"
                :error-messages="updateSoftErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('qualitycheck.product.factoryreset') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.factoryReset"
                :error-messages="factoryResetErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('qualitycheck.product.material') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.material"
                :error-messages="materialResetErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';

export default {
  name: 'ProducttypefiletypeForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {

  },
  data() {
    return {
        name: null,
        namefr: null,
        notice: null,
        updateSoft: null,
        factoryReset: null,
        material: null,
    };
  },
  computed: {
    isLoading() {
      return (
      false
       );
    },

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    namefrErrors() {
      const errors = [];

      if (!this.$v.item.namefr.$dirty) return errors;

      has(this.violations, 'namefr') && errors.push(this.violations.namefr);

      !this.$v.item.namefr.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    noticeErrors() {
      const errors = [];

      if (!this.$v.item.notice.$dirty) return errors;

      has(this.violations, 'notice') && errors.push(this.violations.notice);


      return errors;
    },
    updateSoftErrors() {
      const errors = [];

      if (!this.$v.item.updateSoft.$dirty) return errors;

      has(this.violations, 'updateSoft') && errors.push(this.violations.updateSoft);


      return errors;
    },
    factoryResetErrors() {
      const errors = [];

      if (!this.$v.item.factoryReset.$dirty) return errors;

      has(this.violations, 'factoryReset') && errors.push(this.violations.factoryReset);


      return errors;
    },
    materialErrors() {
      const errors = [];

      if (!this.$v.item.material.$dirty) return errors;

      has(this.violations, 'material') && errors.push(this.violations.material);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {

  },
  validations: {
    item: {
      name: {
        required,
      },
      namefr: {
        required,
      },
      notice: {

      },
      updateSoft: {

      },
      factoryReset: {

      },
      material: {

      },
    }
  }
};
</script>
